import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { ExternalLink } from "lucide-react";

function isSpecificLink(link) {
  return /[?@]|\/place\/|\/search\/|\/maps\/@|q=/.test(link) && link.length > 25;
}

export function buildEmbedQuery(worker) {
  const link = (worker?.link_maps || "").trim();
  if (link && isSpecificLink(link)) return link;
  const place = [worker?.lokasi_kerja, worker?.alamat].filter(Boolean).join(", ");
  return place || link || "Indonesia";
}

export default function MapDialog({ open, onOpenChange, worker }) {
  const query = buildEmbedQuery(worker);
  const embedSrc = `https://www.google.com/maps?q=${encodeURIComponent(query)}&z=12&output=embed`;
  const link = (worker?.link_maps || "").trim();
  const externalHref = /^https?:\/\//i.test(link)
    ? link
    : `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl" data-testid="map-dialog">
        <DialogHeader>
          <DialogTitle>Lokasi Kerja — {worker?.nama}</DialogTitle>
          <DialogDescription>Peta lokasi kerja pekerja berdasarkan data lokasi & alamat.</DialogDescription>
        </DialogHeader>
        <div className="rounded-lg overflow-hidden border border-slate-200">
          <iframe
            title="Peta Lokasi"
            src={embedSrc}
            className="w-full h-[360px]"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            data-testid="map-iframe"
          />
        </div>
        <div className="flex items-center justify-between gap-3">
          <p className="text-sm text-slate-500 truncate">{worker?.lokasi_kerja || "Lokasi belum diatur"}</p>
          <Button asChild variant="outline" className="gap-2 border-blue-200 text-blue-700 hover:bg-blue-50 shrink-0"
            data-testid="open-external-map">
            <a href={externalHref} target="_blank" rel="noopener noreferrer">
              Buka di Google Maps <ExternalLink className="h-4 w-4" />
            </a>
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
